// extracted by mini-css-extract-plugin
export default {"container":"yZ-z","heading":"zZ-z","links":"AZ-z","copy":"BZ-z","subCopy":"CZ-z","linksLeft":"DZ-z","linksCenter":"EZ-z","linksRight":"FZ-z","link":"GZ-z","onlyLink":"HZ-z"};